import { captureError } from "@/helpers/captureError";
import { useMethBankStore } from "@/store/meth-bank";

const { useBapApi } = require("@/api/useBapApi");
const { useToast } = require("@/composables/useToast");
const {
  useToastTransaction,
} = require("@/composables/useToast/useToastTransaction");
const { useWeb3Store } = require("@/store/web3");
const { useOrchestratorContract } = require("@/web3/contracts");

export const claimMethBankMeth = async () => {
  try {
    const web3Store = useWeb3Store();
    const walletAddress = web3Store.walletAddress;
    const { safeClaim } = web3Store;
    let payload = {
      wallet: safeClaim.isController ? safeClaim.sourceWallet : walletAddress,
      controller: safeClaim.isController ? safeClaim.controller : walletAddress,
    };
    const { success, result } = await useBapApi({
      toast: { error: true },
    }).exec({
      method: "POST",
      url: "/mint/sign/claimteenmeth",
      data: payload,
    });

    console.log({ success, result, payload });
    if (!success) {
      useToast().error({ title: "Unexpected Error, please try again" });
      return;
    }

    const { signature, seed, amount, requester } = result;

    if (requester && requester.toLowerCase() !== walletAddress.toLowerCase()) {
      useToast().error({
        title: `Wallet ${requester} has a pending request, please try again in ${(
          (seed - Date.now() / 1000) / 60 +
          1
        ).toFixed(0)} minutes`,
      });
      return;
    }

    const contract = useOrchestratorContract(true);

    const response = await useToastTransaction(
      contract.methods.claimTeenMeth(amount, seed, signature),
      {
        text: "Claiming Meth",
        successText: `Congrats! Your wallet now has +${amount} METH`,
      }
    );
    useMethBankStore().fetchMethBank();
    useWeb3Store().update();
    return response;
  } catch (err) {
    captureError(err);
  }
};
